// utils/deviceId.js
function getDeviceId() {
    let deviceId = localStorage.getItem('deviceId');
    if (!deviceId) {
      // 使用浏览器内置的 crypto.randomUUID() 生成一个唯一 ID（现代浏览器支持）
      if (crypto && crypto.randomUUID) {
        deviceId = crypto.randomUUID();
      } else {
        // 或者使用其他 UUID 生成算法，比如基于时间戳和随机数的简单算法
        deviceId = 'dev-' + Date.now() + '-' + Math.floor(Math.random() * 1000000);
      }
      localStorage.setItem('deviceId', deviceId);
    }
    return deviceId;
  }

export async  function fetchWithDeviceId(url, options = {}) {
    const deviceId = getDeviceId();
    const headers = {
      'Content-Type': 'application/json',
      // 这里将设备 ID 放到请求头中，当然也可以选择放在请求参数中
      'X-Device-ID': deviceId,
      ...options.headers,
    };
    return fetch(url, { ...options, headers });
  }
  